module.exports = __webpack_public_path__ + "media/assets/img/svg/transparent-89267f25cff88340f0aabc24e127e8a2.svg";